import { render, staticRenderFns } from "./CoordinatorModal.vue?vue&type=template&id=db3c1d5e"
import script from "./CoordinatorModal.vue?vue&type=script&lang=js"
export * from "./CoordinatorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports